<template>
<div class="header-inner">
  <Breadcrumbs v-if="hasBreadcrumbs" :items="breadcrumbs" />
  <h1
    ref="title"
    class="header-inner__headaing"
    :data-testid="dataTestid"
  >
    <slot></slot>
  </h1>
</div>
</template>

<script>
import debounce from 'lodash/debounce';

import Breadcrumbs from '@/components/HeaderInner/Breadcrumbs.vue';
import { titleFontResize } from '../../../assets/js/helpers/title-resize';

export default {
  name: 'HeaderInner',
  components: { Breadcrumbs },
  props: {
    breadcrumbs: { type: Array, required: false, default: () => [] },
    resizeType: { type: String, required: false, default: null },
    dataTestid: { type: String, required: false, default: null },
  },
  computed: {
    isResize () {
      return this.resizeType !== null;
    },
    hasBreadcrumbs () {
      return this.breadcrumbs.length > 0;
    },
  },
  mounted() {
    if (this.resizeType) {
      this.resizeTitle();
      window.addEventListener('resize', this.resizeTitle, { passive: true });
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTitle);
  },
  methods: {
    resizeTitle: debounce(function () {
      titleFontResize.reduce(this.$refs.title)
    }, 50),
  },
};
</script>
